import { render } from "./corpProject.vue?vue&type=template&id=616e5a69&scoped=true"
import script from "./corpProject.vue?vue&type=script&lang=js"
export * from "./corpProject.vue?vue&type=script&lang=js"

import "./corpProject.vue?vue&type=style&index=0&id=616e5a69&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616e5a69"]])

export default __exports__